export default (error, code = 422) => error.code === code;
